<template>
    <v-file-input
        v-model="files"
        :rules="required?[rules.multipleFileRequired]:[]"
        color="deep-purple accent-4"
        counter
        :label="label||'File Attachment(s)'"
        multiple
        prepend-icon="mdi-paperclip"
        outlined
        :show-size="1000"
    >
        <template v-slot:selection="{ index, text }">
            <v-chip
                v-if="index < 2"
                color="deep-purple accent-4"
                dark
                label
                small
            >
                {{ text }}
            </v-chip>

            <span
                v-else-if="index === 2"
                class="overline grey--text text--darken-3 mx-2"
            >
        +{{ files.length - 2 }} File(s)
      </span>
        </template>
    </v-file-input>
</template>

<script>
    import {validationMixin} from  "../../src/mixins/validationMixin"
    export default {
        name: "MultipleFileUpload",
        props: {
            label: {
                type: String,
                default: ''
            },
            value: {
                type: null
            },
            required: {
                type: Boolean,
                default: false,
            }
        },
        mixins: [validationMixin],
        watch: {
            files() {
                this.$emit('input', this.files);
            },
            value(new_value) {
                this.files = new_value;
            }
        },
        data() {
            return {
                files: []
            }
        },

    }
</script>

<style scoped>

</style>
